// import userFiles from '../../../../test-data/userFiles.json';

export default {
  userFiles: [],
  userFile: undefined,
};
